import React from 'react';

export const DetailContentText = ({ data, t }) => {
  return (
    <>
      <p className="spec-title">{t("CLUSTER CONTENT")}</p>
      <p className="spec-value">{data.down_cluster}%</p>
    </>
  );
};
